import { FC, ReactNode } from "react";
import styles from "./InfoBanner.module.scss";

type Props = {
  title?: string
  children?: ReactNode
}

const InfoBanner : FC<Props> = ({ title, children }) => {
  return (
    <div className={styles.card}>
      <div className={styles.container}>
        {title && <p>{title}</p>}
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default InfoBanner;